import React from 'react';
export function RefreshSvg() {
    return (React.createElement("svg", { viewBox: "0 0 16 16" },
        React.createElement("path", { fill: "#54b948", d: "M12.9 13A7 7 0 009 1v2.1a5 5 0 012 8.9V8l-2 2v5h5l2-2h-3.1zM2 1L0 3h3.1A7 7 0 007 15v-2.1A5 5 0 015 4v4l2-2V1H2z" })));
}
//# sourceMappingURL=RefreshSvg.js.map